// src/context/NotificationContext.js
import React, { createContext, useContext } from "react";
import { notification } from "antd";

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const [api, contextHolder] = notification.useNotification({
    placement: "topRight",
    maxCount: 3,
  });

  // Wrap each method with a deduplication key so even if called twice in
  // the same tick (e.g. old code paths) only one toast appears.
  const deduped = React.useMemo(() => ({ 
    success: (args) => api.success({ key: args.message, ...args }),
    error:   (args) => api.error({   key: args.message, ...args }),
    warning: (args) => api.warning({ key: args.message, ...args }),
    info:    (args) => api.info({    key: args.message, ...args }),
    open:    (args) => api.open(args),
    destroy: (...a) => api.destroy(...a),
  }), [api]);

  return (
    <NotificationContext.Provider value={deduped}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotify = () => useContext(NotificationContext);
